<template>
  <div class="process-sub-type-selector">
    <b-form-select
      class="processSubTypeList"
      :options="process_sub_type_list"
      v-model="processSubType"
      :title="
        processType == 'p'
          ? 'A valószínűségi megjelenítéshez választható küszöbértékek'
          : 'Kvantilis megjelenítéshez választható kvantilis értékek'
      "
      size="lg"
    >
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "ProcessSubTypeSelector",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    viewType: {
      type: String,
      default: "mapView",
    },
    processType: {
      type: String,
      default: "",
    },
    timeType: {
      type: String,
      default: "",
    },
    variableMap: {
      type: Map,
      default: () => new Map(),
    },
    viewType: {
      type: String,
      default: "mapView",
    },
    modelType: {
      type: String,
      default: "climate",
    },
    qSubTypeMap: {
      type: Map,
      default: () => new Map(),
    },
    variableNotation: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      processSubType: null,
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    process_sub_type_list: function () {
      if (!this.processType || this.viewType == "graphView") {
        return [];
      }
      let variableNotation = this.variableNotation;
      let viewType = this.viewType;
      let modelType = this.modelType;
      let processType = this.processType;
      let variableObject = this.variableMap
        .get(viewType)
        .get(modelType)
        .get(variableNotation);
      //Ezt ki lehetne venni metódusba!
      let sub_types = [];
      let sub_types_to_return = [];
      if (this.processType == "o") {
        sub_types = [0];
      }
      if (this.processType == "p") {
        let p_type_string;
        if (
          variableObject.processing_p_type_seasonal &&
          ["MAM", "JJA", "SON", "DJF"].includes(this.timeType)
          //TODO itt lehet egy bug, nincs definiálva a timeType1
        ) {
          p_type_string = variableObject.processing_p_type_seasonal;
        } else {
          p_type_string = variableObject.processing_p_type;
        }
        sub_types = p_type_string.split(";");
      } else if (this.processType == "q") {
        sub_types = variableObject.processing_q_type.split(";");
      }
      //TODO sub_type feldolgozás objektumba
      //ez csak P-nél, O-nál és q-nál nem

      //TODO: ez így nem jó, mert mindig az elsőt állítja be
      //this.processSubType = sub_types[0]; //csak akkor váltani, ha mindenképpen kell

      if (processType == "p") {
        let sub_type_result = [];
        for (let i = 0; i < sub_types.length; i++) {
          let sub_type_string;
          if (sub_types[i] == "-0")
            sub_type_string = "<0 " + variableObject.unit;
          else
            sub_type_string =
              (sub_types[i] < 0 ? "<" + sub_types[i] : ">" + sub_types[i]) +
              " " +
              variableObject.unit;
          sub_type_result.push({ text: sub_type_string, value: sub_types[i] });
        }
        sub_types_to_return = sub_type_result;
        //return sub_type_result;
      } else if (processType == "q") {
        let sub_type_result = [];
        for (let i = 0; i < sub_types.length; i++) {
          let sub_type_string = this.qSubTypeMap.get(sub_types[i]);
          sub_type_result.push({ text: sub_type_string, value: sub_types[i] });
        }
        sub_types_to_return = sub_type_result;
        //return sub_type_result;
      } else {
        sub_types_to_return = sub_types;
        //return sub_types;
      }
      console.log(sub_types_to_return);
      if (
        this.processSubType == null ||
        sub_types.indexOf(this.processSubType) == -1
      ) {
        console.log("nincs meg a processSubType");
        this.processSubType = sub_types[0];
      } else {
        console.log("megvan a processSubType");
      }
      return sub_types_to_return;
    },
  },
  watch: {
    value(newVal) {
      this.processSubType = newVal;
    },
    processSubType(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped>
.process-sub-type-selector {
  margin-bottom: 1rem;
}

.process-sub-type-select {
  display: block;
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
</style>
